import { getClubById } from '@/api/clubs/clubApi';
import { CLUB_FIELDS } from '@/api/clubs/clubs-fields.config';
import { CategoryRankingPanel } from '@/components/ranking/CategoryRankingPanel';
import { Button } from '@/components/ui/button';
import { getClubSportUids } from '@/utils/club-utils';
import { handleGlobalError } from '@/utils/error-handler';
import { ChevronLeft, Trophy } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const ClubRanking: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const clubId = params.id || location.state?.clubId;

  const [clubName, setClubName] = useState('');
  // undefined while the club loads, null when it failed — the panel tells them apart.
  const [clubSportUids, setClubSportUids] = useState<string[] | null>();

  useEffect(() => {
    if (!clubId) {
      navigate('/clubs');
      return;
    }
    getClubById(clubId, CLUB_FIELDS.COURT_SPORTS)
      .then((club) => {
        setClubName(club.name);
        setClubSportUids(getClubSportUids(club.courts));
      })
      .catch((error) => {
        setClubSportUids(null);
        handleGlobalError(error, 'Error', 'No se pudo cargar el club.');
      });
  }, [clubId, navigate]);

  return (
    <div className="mb-8">
      <div className="mb-6 flex items-center gap-3">
        <Button
          type="button"
          variant="ghost"
          onClick={() => navigate('/clubs')}
          className="flex items-center gap-2"
        >
          <ChevronLeft size={16} />
        </Button>
        <Trophy size={28} className="text-yellow-600" />
        <div>
          <h2 className="text-2xl font-bold">Ranking de categoría</h2>
          <p className="mt-1 text-sm text-gray-600">{clubName}</p>
        </div>
      </div>

      <CategoryRankingPanel clubId={clubId} clubSportUids={clubSportUids} />
    </div>
  );
};

export default ClubRanking;
